import { skipToken } from "@reduxjs/toolkit/query";
import type { OutcomeCondition } from "@repo/app-types/entities/filterConditions";
import {
  getOutcomeDefinitionFromPlaybook,
  type PlaybookId,
} from "@repo/app-types/entities/playbook";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { usePlaybookByIdQuery } from "../../api/entities/playbook.js";
import { OutcomeConditionsMenu } from "./outcomeConditionsMenu.js";

export interface OutcomeFilterOptionProps {
  params: { playbookId?: PlaybookId };
  value: OutcomeCondition | null;
  onChange: (newValue: OutcomeCondition | null) => void;
}

export const OutcomeFilterOption: FC<OutcomeFilterOptionProps> = ({
  params,
  value,
  onChange,
}) => {
  const playbookId = params.playbookId;
  const { data: playbook } = usePlaybookByIdQuery(playbookId ?? skipToken);
  const outcomeDefinition = getOutcomeDefinitionFromPlaybook(playbook);

  if (value !== null || playbookId === undefined || !outcomeDefinition) {
    return null;
  }

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>{outcomeDefinition.name}</SimpleMenuItem>

      <SimpleMenuPopover>
        <OutcomeConditionsMenu
          playbookId={playbookId}
          outcomeDefinition={outcomeDefinition}
          onSelect={onChange}
        />
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
